import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import StyleSheet from 'styles'
import FlexDataView, { FlexDataItem } from 'components/FlexDataView'
import { Project, DateDisplay, Allocation, Payment, Commission, Rates, TextDetails } from './'
import { Authorization } from 'utils'

export class Summary extends Component{

  static propTypes = {
    dealSheet: PropTypes.object.isRequired,
    onPreview: PropTypes.func,
    onPublish: PropTypes.func,
    currencyPrice: PropTypes.any,

  }

  render = () => {
    const {dealSheet, onPreview, onPublish, currencyPrice} = this.props
    const isEquity = dealSheet.typeOfIssuance === 'equity'
    return (
      <div>
        <div className={styles.heading}>
          <Typography variant='h6'>Deal Summary</Typography>
          <div>
            {this.props.dealSheet.status === 'approved' && Authorization.admin &&
              <Button className={styles.previewBtn} variant="contained" color='secondary' onClick={onPublish}>Publish</Button>
            }
            {this.props.dealSheet.id &&
              <Button className={styles.previewBtn} variant="contained" color='primary' onClick={onPreview}>Preview</Button>
            }
          </div>
        </div>

        <FlexDataView>
          <Project dealSheet={dealSheet}/>
          <FlexDataItem size="large">
            <FlexDataView className={styles.flexContainer}>
              <DateDisplay label="Start Date" type="Start" date={dealSheet.startDate} />
              <DateDisplay label="End Date" type="End" date={dealSheet.endDate} />
              {!isEquity &&
                <Allocation dealSheet={dealSheet}/>
              }
              <Payment dealSheet={dealSheet} />
            </FlexDataView>
          </FlexDataItem>
          {Authorization.admin && <Commission dealSheet={dealSheet}/>}
          {!isEquity && <Rates dealSheet={dealSheet} currencyPrice={currencyPrice} />}
        </FlexDataView>

        <TextDetails dealSheet={dealSheet}/>
      </div>
    )
  }
}

const styles = StyleSheet({
  previewBtn: {

  },
  heading: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 25,
    '& button': {
      marginLeft: 10
    }
  },
})

export default Summary